import { render } from "./interests-page.vue?vue&type=template&id=2b6da820&ts=true"
import script from "./interests-page.vue?vue&type=script&lang=ts"
export * from "./interests-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__